import React, { useContext } from "react";
import Modal from "../../components/Modal";
import { ModelCxContext } from "../../context/modelCx.context";
import TextArea from "../../components/TextArea";

function LocationMetaModal({ currentLocation, setOpenLocationMetaModal }) {
  const { awsgwOfficeMetaDataResult } = useContext(ModelCxContext);

  // - - - - - - - - - -

  const onClose = () => {
    setOpenLocationMetaModal({ show: false });
  };

  // - - - - - - - - - -

  return (
    <Modal onClose={() => onClose()}>
      <Modal.Header>
        <div className="flex justify-between">
          <div>Location Information</div>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className="flex flex-col gap-4 w-[400px]">
          <div className="text-lg font-bold">{currentLocation}</div>
          <div className="flex flex-col gap-1 p-2 bg-skin-surface-hard">
            <div>
              <TextArea
                readOnly={true}
                placeholder="Custom Notes"
                rows={20}
                value={awsgwOfficeMetaDataResult?.ScheduleInfo}
                className="bg-skin-base border border-black/20 "
              ></TextArea>
            </div>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
}

export default LocationMetaModal;
